import React, { useState, useRef } from "react";
import "./checkout.css";
import { useLocation, useNavigate } from "react-router-dom";
import Service from "../../services/service";
import discount from "../../assets/Images/discount.png";
import { showSuccessToast } from "utils/toastNotification";
import AddressHelp from "component/AddressHelp";
import CheckoutStepper from "component/CheckoutStepper/CheckoutStepper";

const Checkout = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const totalItems = state?.cartData;
  const [paymentLoading, setPaymentLoading] = useState(false);
  const paymentInitiatedRef = useRef(false);

  const totalCartItems = state?.totalCart;

  console.log(totalCartItems);

  const mrpAmount = totalItems.reduce(
    (sum, item) => sum + item.customTShirtPrint.product.price * item.quantity,
    0
  );

  const totalDiscountedPrice = totalItems.reduce(
    (sum, item) => sum + item.customTShirtPrint.product.discountPrice * item.quantity,
    0
  );

  const discountAmount = mrpAmount - totalDiscountedPrice;
  const couponDiscount = totalCartItems?.discountAmountOnCoupon || 0;
  const finalTotal = totalDiscountedPrice - couponDiscount;

  const payload = {
    cartId: totalCartItems._id,
  };

  const initializePayment = async () => {
    if (paymentLoading || paymentInitiatedRef.current) return;
    paymentInitiatedRef.current = true;
    setPaymentLoading(true);
    try {
      const data = await Service.initiatePurchase(payload);
      const orderId = data.data.data.orderId; // Store the order ID
      const options = {
        key: "rzp_live_SlF5HqyyNWkzva",
        currency: "INR",
        name: "rekhacollection",
        description: "Payment for the product.",
        order_id: orderId, // Pass the Razorpay order ID
        handler: async (response) => {
          console.log("Handler response:", response);

          try {
            // Verify the payment on the server
            const verifyResponse = await Service.verifyPurchase({
              razorpayPaymentId: response.razorpay_payment_id,
              orderId: orderId, // Use stored order ID
              razorpaySignature: response.razorpay_signature,
            });
            showSuccessToast("Payment Successful");
            navigate("/OrderConfirm", {
              state: {
                verificationData: verifyResponse.data.data,
              },
            });
          } catch (verifyError) {
            console.error("Payment verification error:", verifyError);
            alert("Error verifying payment. Please contact support.");
          }
        },

        theme: {
          color: "#1f1f1d",
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.on("payment.failed", (response) => {
        console.error("Payment Failed:", response.error);
        alert("Payment Failed. Please try again.");
        paymentInitiatedRef.current = false;
      });

      razorpay.open();
    } catch (error) {
      console.error("Error initializing payment:", error);
      alert("Error initializing payment. Please try again later.");
      paymentInitiatedRef.current = false;
    } finally {
      setPaymentLoading(false);
    }
  };

  return (
    <div className="checkout">
      <CheckoutStepper currentStep={2} />
      <div className="checkout__column">
        <div className="checkout__details">
          <div className="checkout__details__column">
            <AddressHelp />

            <div className="checkout__summary">
              <div className="checkout__summary__column">
                <h3 className="checkout__details__title ui heading size-headingmd">
                  PRICE DETAILS ({totalItems.length} Items)
                </h3>
                <div className="checkout__summary__details">
                  <div>
                    <div className="checkout__summary__item">
                      <p className="checkout__details__upi-id-label ui text size-text2xl">
                        Total MRP
                      </p>
                      <p className="checkout__details__upi-id-label ui text size-text2xl">
                        ₹{mrpAmount.toFixed(2)}
                      </p>
                    </div>
                    <div className="checkout__summary__item-1">
                      <div className="checkout__summary__discount-row">
                        <p className="checkout__details__upi-id-label ui text size-text2xl">
                          Discount on MRP
                        </p>
                      </div>
                      <p className="checkout__summary__discount-value ui text size-text2xl">
                        -₹{discountAmount.toFixed(2)}
                      </p>
                    </div>

                    <div className="checkout__summary__item-1">
                      <div className="checkout__summary__discount-row">
                        <p className="checkout__details__upi-id-label ui text size-text2xl">
                          Discount on Coupon
                        </p>
                      </div>
                      <p className="checkout__summary__discount-value ui text size-text2xl">
                      - ₹{couponDiscount.toFixed(2)}
                      </p>
                    </div>
                    <div className="checkout__summary__total-row">
                      <h6 className="checkout__details__title ui heading size-headingmd">
                        Total Amount
                      </h6>
                      <h5 className="checkout__details__title ui heading size-headingmd">
                        ₹{finalTotal.toFixed(2)}
                      </h5>
                    </div>
                  </div>
                  <button
                    className="flex-row-center-center checkout__summary__button ui button deep_orange_700 size-2xl fill round"
                    onClick={initializePayment}
                    disabled={paymentLoading}
                  >
                    {paymentLoading ? "Processing..." : "Confirm"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
